import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription, debounceTime } from 'rxjs';

@Directive({
  selector: '[noDoubleClick]'
})
export class NoDoubleClickDirective implements OnInit, OnDestroy {
  @Input() debounceTime = 500;
  @Output() debounceClick = new EventEmitter();
  private clicks = new Subject();
  private subscription: Subscription;

  constructor() { }

  ngOnInit() {
    this.subscription = this.clicks.pipe(debounceTime(this.debounceTime)).subscribe(e => this.debounceClick.emit(e));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * @description This directive will disable the button 
   * for {DEBOUNCE_TIME} seconds. This is used to prevent the user 
   * from tapping a button in a quick succession and making redundant API calls
   */
  @HostListener('click', ['$event'])
  clickEvent(event) {
    (event.target as HTMLButtonElement).disabled = true;
    setTimeout(()=>{
      (event.target as HTMLButtonElement).disabled = false;
    }, 2000);
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}